/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { css } from 'styled-components';
/* stylelint-disable plugin/no-z-index */

const stacking = {
  modal: css`
    z-index: 9000;
  `,
  overlay: css`
    z-index: 8000;
  `,
  menu: css`
    z-index: 7000;
  `,
  header: css`
    z-index: 6000;
  `,
  banner: css`
    z-index: 5000;
  `,
  contentAction: css`
    z-index: 2000;
  `,
  underneath: css`
    z-index: -1;
  `
};

export default stacking;
